// This is the main component where a Playbook with its tabs, tiles and dashboard is rendered
// The page is further grouped into DataViewerMiddle & DataViewerBottom components
//
// 	- DataViewerMiddle holds the following
// 		- drop zones for table columns,
// 		- graph area,
// 		- all the chart control actions

// 	- DataViewerBottom holds the following
// 		- selectedDataset list to work with this playbook,
// 		- list of tables for this dataset &
// 		- Sample records from selected table

import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Suspense } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import update from 'immutability-helper';
import './dataViewer.css';
import { connect, useSelector } from 'react-redux';
import { setDefaultThemeId, toggleDashModeInTab } from '../../redux/TabTile/TabActions';
import {
  callQueryAPIDashboard,
  toggleDashMode,
} from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import TabRibbon from '../TabsAndTiles/TabRibbon';
import { Info } from 'lucide-react';
import { styled } from '@mui/material/styles';
import { TabTileStateProps, TabTileStateProps2 } from '../../redux/TabTile/TabTilePropsInterfaces';
import TableRowsIcon from '@mui/icons-material/TableRows';
import CloseIcon from '@mui/icons-material/Close';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import TileRibbon from '../TabsAndTiles/TileRibbon';
import { Dispatch } from 'redux';
import {
  ButtonGroup,
  Tooltip,
  Button,
  Typography,
  Checkbox,
  Switch,
  MenuItem,
  Select,
  FormControl,
} from '@mui/material';
import DataViewerMiddle from './DataViewerMiddle';
import DataViewerBottom from './DataViewerBottom';
import {
  setSelectedControlMenu,
  setShowDashBoard,
  toggleColumnsOnlyDisplay,
  toggleShowDataViewerBottom,
} from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';

import MenuBar from './MenuBar/MenuBar';
import DashBoard from '../DashBoard/DashBoard';
import {
  setTVSelectedTabs,
  setTVTransitionTime,
  setTVDataRefreshEnabled,
  setTVDataRefreshUnit,
  setTVDataRefreshTime,
} from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { ChartPropertiesProps } from '../../redux/ChartPoperties/ChartPropertiesInterfaces';
import { TabStateProps } from '../../redux/TabTile/TabStateInterfaces';
import { TileStateProps } from '../../redux/TabTile/TileStateInterfaces';
import { setSelectedDsInTile } from '../../redux/ChartPoperties/ChartPropertiesActions';
import FetchData from '../ServerCall/FetchData';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import useCombinedColorSchemes from '../../hooks/useCombinedColorSchemes';
import { isColorDark } from '../ChartOptions/Color/ChartColorComponents/colorUtils';
import SettingsIcon from '@mui/icons-material/Settings';
import LayersIcon from '@mui/icons-material/Layers';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import {
  setSelectedDataSetList,
  setTablesForSelectedDataSets,
} from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { setSelectedDatasetForDynamicMeasure } from '../../redux/DynamicMeasures/DynamicMeasuresActions';
import {
  changeChartDataToAxesOrder,
  checkIfMissingColumn,
} from '../CommonFunctions/CommonFunctions';
import { getPrivilegeForPlayBook } from '../../api/playbookApi';
import { getTableData } from '../../api';
import { getColumnTypes } from '../../api';
import { updatePlaybookUid } from '../../redux/PlayBook/PlayBookActions';
import { loadPlaybook } from '../../redux/TabTile/actionsTabTile';
import { fontSize, palette } from '../..';

import { PopUpSpinner } from '../CommonFunctions/DialogComponents';
import Logger from '../../Logger';
import { RootState } from '../../redux';
import { useDispatch } from 'react-redux';
import {
  callQueryAPI,
  initializeGaugeChartFormats,
  initializeTooltipFormatState,
} from '../../redux/ChartPoperties/ChartControlsActions';
import { GeoJSON } from '../Charts/GeoChart/Components/MapCommonComponents';
import { initializeShowHide } from '../ChartOptions/ShowHide/initialiseShowHide';
import fetchUserThemes from '../../api/fetchUserThemes';
import { clearCachedThemes } from '../../api/fetchUserThemes';
import { fetchUniqueOptions } from '../../api/filters';
import { Helmet } from 'react-helmet-async';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { localEndPoint } from '../ServerCall/EnvironmentVariables';
import { ICalculationInfo } from '../../redux/Calculations/CurrentCalculationSessionInterface';
import { ColorLensOutlined } from '@mui/icons-material';
import { orderByDependency } from '../Calculations/utils';
import { IFlows } from '../../redux/Calculations/CurrentCalculationSessionInterface';
interface DataViewerProps {
  tabTileProps: TabTileStateProps;
  chartProperties: ChartPropertiesProps;
  tabState: TabStateProps;
  tileState: TileStateProps;
  showDashBoard: (tabId: number, showDash: boolean) => void;
  toggleDataViewerBottom: (show: boolean) => void;
  toggleColumns: (displayOnlyCol: boolean) => void;
  setMenu: (menu: string) => void;
  handleMenuClose?: () => void;
  from?: string;
  saveAndNavigateTo?: (path: string) => void;
  navigatetTo?: any;
}

function DataViewer({
  //state
  isFromSharedLink = false,
  tabTileProps,
  chartProperties,
  pageSettings,
  token,
  calculations,
  chartControls,

  // dispatch
  loadPlayBook,
  updatePlayBookId,
  showDashBoard,
  toggleDataViewerBottom,
  toggleColumns,
  setMenu,
}: any) {
  const {
    tabState,
    tvSettings,
    playbookState,
    chartFilterGroup,
    dashBoardFilterGroup,
    parameterState,
  } = useSelector((state: RootState) => ({
    tabState: state.tabState,
    tvSettings: state.tabTileProps.tvSettings,
    playbookState: state.playBookState,
    chartFilterGroup: state.chartFilterGroup,
    dashBoardFilterGroup: state.dashBoardFilterGroup,
    parameterState: state.parameters,
  }));
  const [showListofTileMenu, setShowListofTileMenu] = useState<boolean>(true);
  const [dashboardResizeColumn, setDashboardResizeColumn] = useState<boolean>(false);
  const [showDashboardFilter, setShowDashboardFilter] = useState<boolean>(false);
  const [showDashboardFilterEdit, setShowDashboardFilterEdit] = useState<boolean>(false);
  const [iconAlign, setIconAlign] = useState<'left' | 'right'>('right');
  const [reportFilterMenu, setReportFilterMenu] = useState<boolean>(false);
  const [parameterMenu, setParameterMenu] = useState<boolean>(false);
  const [mapJSON, setMapJSON] = useState<GeoJSON>();

  const {
    selectedTabArray,
    transitionTime,
    dataRefreshEnableds,
    dataRefreshUnit,
    dataRefreshTime,
  } = tvSettings;

  const [showObjectsSidebar, setShowObjectsSidebar] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [disabledTVDisp, setDisabledTVDisp] = useState<boolean>(false);
  const [disabledMessage, setDisabledMessage] = useState<string | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(location.search);
  const workspaceId = searchParams.get('workspaceId');
  const playbookId = searchParams.get('playbookId');
  const urlTabName = searchParams.get('tabName');
  const tenantId = searchParams.get('tenantId');
  const shareDashboardLink = searchParams.get('dashboard');

  const CustomButton = styled(Button)({
    backgroundColor: 'white',
    border: '1px solid #2bb9bb',
    color: '#2bb9bb',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#2bb9bb',
      color: 'white',
    },
    '&.Mui-disabled': {
      border: '1px solid #ccc',
    },
  });
  const allThemes = useCombinedColorSchemes();

  useEffect(() => {
    dispatch(
      setTVSelectedTabs(
        tvSettings.selectedTabArray.filter((id: number) => tabState.tabList.includes(id)),
      ),
    );
  }, [tabState.tabList]);
  useEffect(() => {
    //only syncking tabName to URL if we're still on the playbook page
    // and have valid playbook search params. This prevent the effect from
    // firing during back-button navigation when resetAllStates() clears
    // the Redux state and triggers a tabState.tabs change.
    const isOnPlaybook = window.location.pathname.startsWith('/playbook');
    const currentParams = new URLSearchParams(window.location.search);
    const hasPlaybookParams = currentParams.has('workspaceId') || currentParams.has('playbookId');

    if (!isOnPlaybook || !hasPlaybookParams) return;

    if (tabState.tabs && tabTileProps.selectedTabId) {
      const activeTab = tabState.tabs[tabTileProps.selectedTabId];

      if (activeTab && activeTab.tabName) {
        const encodedTabName = encodeURIComponent(activeTab.tabName);

        const params = new URLSearchParams(searchParams);
        params.delete('tabName');

        const restQuery = params.toString();

        const finalQuery = restQuery
          ? `${restQuery}&tabName=${encodedTabName}`
          : `tabName=${encodedTabName}`;

        navigate(`${location.pathname}?${finalQuery}`, { replace: true });
      }
    }
  }, [tabTileProps.selectedTabId, tabState.tabs]);

  const axisOptionsOldStructureDetected = (axisNameOption: {
    [key: string]: string | number | boolean | string[];
  }) => {
    const axisOptionKeys = Object.keys(axisNameOption);
    if (!axisOptionKeys[0].startsWith('1')) return true;
    return false;
  };

  const modifyAxisOptionsOldStructure = (axisOptions: any, axisName: string) => {
    const tempAxisOptions = JSON.parse(JSON.stringify(axisOptions[axisName]));
    for (let key in axisOptions[axisName]) {
      const axisNameOption = axisOptions[axisName];
      delete axisNameOption[key];
    }

    const axisMinMax = axisOptions.axisMinMax;
    const newlyAddedStates = {
      ...axisMinMax,
      measuresList: [],
    };
    axisOptions[axisName][1] = { ...newlyAddedStates, ...tempAxisOptions };
  };

  const axisFormatOldStructureDetected = (formatOptions: any, axisFormatName: string) => {
    const axisFormatKeys = Object.keys(formatOptions[axisFormatName]);
    if (!axisFormatKeys[0].startsWith('1')) return true;
    return false;
  };

  const modifyAxisFormatOldStructure = (formatOptions: any, axisFormatName: string) => {
    const tempAxisFormats = JSON.parse(JSON.stringify(formatOptions[axisFormatName]));
    for (let key in formatOptions[axisFormatName]) {
      const axisNameFormat = formatOptions[axisFormatName];
      delete axisNameFormat[key];
    }
    const newlyAddedStates = {
      formatValue: 'Number',
      currencySymbol: '$',
      percentageCalculate: false,
    };
    formatOptions[axisFormatName][1] = { ...tempAxisFormats, ...newlyAddedStates };
  };

  const { tabAreaBackgroundColor, iconColor, selectedTabBackgroundColor, dashIconColor } =
    useMemo(() => {
      if (!tabTileProps.showDash) {
        return {
          tabAreaBackgroundColor: '#ffffff',
          iconColor: '#5e5e5e',
        };
      }

      const activeTabId = tabTileProps.selectedTabId;

      if (!activeTabId) {
        return { tabAreaBackgroundColor: '#ffffff', iconColor: '#5e5e5e' };
      }

      const dashTheme = tabState.tabs[activeTabId]?.dashboardState?.colorScheme;
      const scheme_passed =
        dashTheme ??
        chartControls.properties[Object.keys(chartControls.properties)[0]]?.colorScheme ??
        'peacock';

      const selectedScheme = allThemes.find((scheme) => scheme.name === scheme_passed);

      let isDarkTheme = false;
      if (selectedScheme) {
        if (selectedScheme.dark !== undefined) {
          isDarkTheme = selectedScheme.dark === true;
        } else if (selectedScheme.background) {
          isDarkTheme = isColorDark(selectedScheme.background);
        }
      }

      const lightThemeSelectedColor = 'rgba(224, 224, 224, 1)';
      const darkThemeSelectedColor = 'rgba(255, 255, 255, 0.15)';
      let finalSelectedTabColor;

      if (selectedScheme?.name === 'essos') {
        finalSelectedTabColor = 'rgba(249, 236, 142, 1)';
      } else if (isDarkTheme) {
        finalSelectedTabColor = darkThemeSelectedColor;
      } else {
        finalSelectedTabColor = lightThemeSelectedColor;
      }

      return {
        tabAreaBackgroundColor: selectedScheme ? selectedScheme.background : '#ffffff',
        iconColor: isDarkTheme ? '#ffffff' : '#646363ff',
        dashIconColor: isDarkTheme ? '#ffffff' : '#908f8fff',
        selectedTabBackgroundColor: finalSelectedTabColor,
      };
    }, [tabTileProps.showDash, tabState, tabTileProps.selectedTabId, chartControls, allThemes]);
  useEffect(() => {
    if (selectedTabArray.length < 1) {
      setDisabledTVDisp(true);
      setDisabledMessage('Choose atleast one tab');
    } else if (transitionTime < 5) {
      setDisabledTVDisp(true);
      setDisabledMessage(null);
    } else if (
      dataRefreshEnableds &&
      ((dataRefreshUnit === 'Minutes' && dataRefreshTime < 5) ||
        (dataRefreshUnit === 'Hours' && dataRefreshTime < 1))
    ) {
      setDisabledTVDisp(true);
      setDisabledMessage(null);
    } else {
      setDisabledTVDisp(false);
      setDisabledMessage(null);
    }
  }, [tvSettings]);

  const [showDataViewer, setShowDataViewer] = useState<boolean>(true);
  // const [linkErrorMessage, setLinkErrorMessage] = useState<string | null>(null);
  const [selectedTabs, setSelectedTabs] = useState<number[]>(selectedTabArray);
  // const [tvDataRefreshUnit, setTvDataRefreshUnit] = useState<"Minutes" | "Hours">(dataRefreshUnit);
  // const [dataRefreshEnabled, setDataRefreshEnabled] = useState<boolean>(dataRefreshEnableds); // or false by default
  const [disableEdit, setDisableEdit] = useState<boolean>(false);
  // const [tvTransitionTime, setTvTransitionTime] = useState(transitionTime); // default: 10 secs
  // const [tvDataRefreshTime, setTvDataRefreshTime] = useState(dataRefreshTime); // default: 5 mins

  const state = location.state;
  const propKey = useMemo(
    () => `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`,
    [tabTileProps.selectedTabId, tabTileProps.selectedTileId],
  );
  const currentCalculationSession = calculations.properties[propKey]?.currentCalculationSession;

  const hasFilters = Object.values(chartFilterGroup.groups || {}).some(
    (group: any) => group.filters && group.filters.length > 0,
  );

  const hasParameters = parameterState?.savedParameters?.some((param: any) => param.showParameter);

  const isFilterDisabled = !hasFilters && !hasParameters;

  const activeDashboardState = tabState.tabs[tabTileProps.selectedTabId]?.dashboardState;
  const filterVisibilityMode =
    activeDashboardState?.filterVisibilityMode?.toLowerCase() || 'present';
  const filterPanelMode = activeDashboardState?.filterPanelMode?.toLowerCase() || 'expand';

  useEffect(() => {
    const fetchPrivilege = async () => {
      if (shareDashboardLink || (!state?.playbookId && !playbookId)) {
        setDisableEdit(false);
        return;
      }
      const permissionRes = await getPrivilegeForPlayBook(
        token,
        state?.parentId || workspaceId,
        state?.playbookId || playbookId,
      );
      if (permissionRes.status) {
        setDisableEdit(!permissionRes.data.levelId || permissionRes.data.levelId === 3);
      } else {
        setDisableEdit(true); //
        navigate('/access-restricted');
      }
    };
    fetchPrivilege();
  }, [state?.playbookId, token, state?.parentId, playbookId, workspaceId]);

  // const goToTVDisplay = () => {
  //   const pathParts = window.location.pathname.split('/');
  //   const dashboardId = pathParts[pathParts.length - 1];
  //   navigate(`/display/${dashboardId}?workspaceId=${workspaceId}&playbookId=${playbookId}`, {
  //     state: { ...location.state, disableEdit },
  //   });
  // };

  // To redirect to home page if their is no dataset selected
  const newref = useRef(false);

  useEffect(() => {
    if (!newref.current) {
      newref.current = true;
      return;
    }

    // check if user is currently on playbook page to avoid unnecessary redirection to home page
    const isCurrentlyOnPlaybook = window.location.pathname.startsWith('/playbook');
    if (!isCurrentlyOnPlaybook) return;

    // Data Check
    const hasNoDataset =
      !tabTileProps.selectedDataSetList || tabTileProps.selectedDataSetList.length === 0;

    if (tabTileProps.showDash && hasNoDataset && state?.mode === 'New') {
      navigate('/');
    }
  }, [tabTileProps.selectedDataSetList, tabTileProps.showDash, state?.mode]);

  // this useEffect is for filter visibility
  useEffect(() => {
    if (tabTileProps.showDash) {
      if (tabTileProps.dashMode === 'Present') {
        let shouldShow = false;

        if (filterVisibilityMode === 'always') {
          if (filterPanelMode === 'expand') shouldShow = true;
        } else if (filterVisibilityMode === 'present') {
          if (filterPanelMode === 'expand' && (hasFilters || hasParameters)) {
            shouldShow = true;
          }
        }

        setShowDashboardFilter(shouldShow);
      }
    }
  }, [
    tabTileProps.showDash,
    tabTileProps.selectedTabId,
    tabTileProps.dashMode,
    filterVisibilityMode,
    filterPanelMode,
    hasFilters,
    hasParameters,
  ]);

  useEffect(() => {
    Object.keys(chartFilterGroup.tabTile).forEach((tabTileId: string) => {
      if (
        tabState.tabs[tabTileProps.selectedTabId].tilesInDashboard.includes(tabTileId) &&
        isDashboardFilterDifferent(tabTileId)
      ) {
        if (!chartControls.properties[tabTileId].callQueryAPI)
          dispatch(callQueryAPI(tabTileId, true));
        if (tabTileProps.showDash) dispatch(callQueryAPIDashboard(true));
      }
    });
  }, [tabTileProps.showDash]);

  const isDashboardFilterDifferent = (tabTileId: string) => {
    const compareFilters: string[] = [];

    Object.entries(dashBoardFilterGroup.filterGroupTabTiles).forEach(([key, arr]: any) => {
      if (arr.includes(tabTileId)) {
        compareFilters.push(key);
      }
    });
    return (
      JSON.stringify([...compareFilters].sort()) !==
      JSON.stringify([...chartFilterGroup.tabTile[tabTileId]].sort())
    );
  };

  // if (!state) {
  //   return null; //////////////////////////////////////////////////////////////////
  // }

  const getPlaybookdataForLinkId = async (link: string): Promise<boolean> => {
    try {
      setLoading(true);
      var result = await FetchData({
        checkToken: false,
        requestType: 'noData',
        method: 'GET',
        url: `view/playbook/open-link/${link}`,
        headers: { 'X-TENANT-ID': tenantId || 'community' },
      });

      if (result.status) {
        await loadPlayBookContent(result.data, true);
        return true;
      } else {
        setShowDataViewer(false);
        setLoading(false);

        //  setLinkErrorMessage(errorMessage);
        return false;
      }
    } catch (err) {
      Logger('error', 'Error fetching playbook data', err);
      return false;
    }
  };

  // Whether to show table at the bottom of page or not
  const handleTableDisplayToggle = () => {
    toggleDataViewerBottom(!tabTileProps.showDataViewerBottom);
  };

  const getPlayBookDataFromServer = async (pbUid: string) => {
    setLoading(true);
    var result: any = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url: `playbook/${pbUid}?workspaceId=${state?.parentId || workspaceId}`,
      headers: { Authorization: `Bearer ${token}` },
    });

    if (result.status) {
      await loadPlayBookContent(result?.data?.content, false);
    } else setLoading(false);
  };

  useEffect(() => {
    (async () => {
      clearCachedThemes();
      if (!state && !isFromSharedLink && !playbookId && !workspaceId) {
        navigate('/');
      } else if (state && state.mode === 'fromTVDisplay') {
        if (!playbookState.playBookUid) {
          setShowDataViewer(true);
          await getPlayBookDataFromServer(state.playbookId || playbookId);
        }
        return;
      } else if (state && state.mode === 'New') {
        // For new playbook, always open Tile-1 and not Dashboard
        showDashBoard(tabTileProps.selectedTabId, false);
      } else if (!state && workspaceId && !playbookId && !shareDashboardLink) {
        // Unsaved playbook reload: keep tile mode so dataset picker opens.
        showDashBoard(tabTileProps.selectedTabId, false);
      } else if (state?.link || shareDashboardLink) {
        const success = await getPlaybookdataForLinkId(state?.link || shareDashboardLink);
        if (success) {
          setShowDataViewer(true);
        }
      } else if ((state && state.playbookId) || (playbookId && workspaceId && urlTabName)) {
        await getPlayBookDataFromServer(state?.playbookId || playbookId);
        setShowDataViewer(true);
      }

      const { defaultThemeId } = await fetchUserThemes();

      const activeTabId = tabTileProps.selectedTabId;
      if (activeTabId) {
        dispatch(setDefaultThemeId(activeTabId, defaultThemeId));
      }
    })();
  }, [state, playbookId, workspaceId]);

  const loadPlayBookContent = async (data: any, isFromLink: boolean) => {
    let pb: any = {};

    // if (isFromLink) {
    //   pb.content = {};
    //   pb.content['content'] = data;
    // } else {
    pb.content = JSON.parse(JSON.stringify(data));
    pb.content.content = JSON.parse(pb.content.content);
    // }

    //  SORT THE ALL SAVED CALCULATIONS
    const savedCalculations = pb.content.content?.calculations?.savedCalculations;

    if (savedCalculations?.length > 0) {
      for (const calc of savedCalculations) {
        const calcInfo = calc?.calculationInfo;
        if (!calcInfo?.flows) continue;

        const { orderedFlows } = orderByDependency(calcInfo);

        /** no need to check error for order as its already a saved calculation */

        const sortedFlows: IFlows = {};

        for (const flowId of orderedFlows) {
          sortedFlows[flowId] = calcInfo.flows[flowId];
        }
        calcInfo.flows = sortedFlows;
      }
    }

    let listOfPropKeys = Object.keys(pb.content.content?.chartControl?.properties);

    /*  Prakash 09/Nov/2024 Always open the playbook in Dashboad Present Mode */
    if (state?.mode !== 'Save' || isFromLink) {
      // if coming from save as no need to change dashMode and showDash
      pb.content.content.tabTileProps.dashMode = 'Present';
      pb.content.content.tabTileProps.showDash = true;
    }

    /*  Prakash 09/Nov/2024 Always open the playbook in Dashboad Present Mode */

    listOfPropKeys.forEach((propKey: string) => {
      pb.content.content.chartProperty.properties[propKey].modified = 'axis';
      if (
        pb.content.content.chartControl.properties[propKey].chartData &&
        pb.content.content.chartControl.properties[propKey].chartData.length > 0
      ) {
        pb.content.content.chartControl.properties[propKey].chartData = changeChartDataToAxesOrder(
          pb.content.content.chartControl.properties[propKey].chartData,
          pb.content.content.chartProperty,
          propKey,
        );
      }
      pb.content.content.chartControl.properties[propKey].callQueryAPI = true;
    });

    var selectedDatasetsInPlaybook = pb.content.content?.tabTileProps?.selectedDataSetList || [];

    // Get list of tables for a given dataset and save here
    var tablesForSelectedDatasetsCopy: any = {};
    const extract: { [dsId: string]: boolean } = {};

    if (!isFromLink) {
      await Promise.all(
        selectedDatasetsInPlaybook.map(async (sampleDs: any, idx: number) => {
          var result2: any = await FetchData({
            requestType: 'noData',
            method: 'GET',
            url: `dataset/${sampleDs.id}?workspaceId=${state?.parentId || workspaceId}`,
            headers: { Authorization: `Bearer ${token}` },
          });

          if (result2.status) {
            // tablesForSelectedDatasetsCopy[sampleDs.id] = result2.data;
            tablesForSelectedDatasetsCopy[sampleDs.id] = result2.data.dataSchema.tables;
            extract[sampleDs.id] = result2.data.isExtract || result2.data.isFlatFileData || false;

            // to update the name of the dataset if changes
            pb.content.content.tabTileProps.selectedDataSetList[idx] = {
              ...pb.content.content.tabTileProps.selectedDataSetList[idx],
              datasetName: result2.data?.datasetName,
            };
          }
        }),
      );
    }

    //pb.content.content = JSON.parse(pb.content.content);

    pb.content.content.tabTileProps.tablesForSelectedDataSets = tablesForSelectedDatasetsCopy;
    pb.content.content.tabTileProps.tvSettings = tvSettings;
    pb.content.content.tabTileProps.callQueryAPIDashboard = true;

    // for each tile in playbook, if it has minimum required cards in dropzones, get chart data from server
    var newChartControl = JSON.parse(JSON.stringify(pb.content.content?.chartControl));
    var axesValue;
    await Promise.all(
      Object.keys(pb.content.content.chartControl.properties).map(async (property) => {
        axesValue = JSON.parse(
          JSON.stringify(pb.content.content.chartProperty.properties[property].chartAxes),
        );
        var minReq: any = true;
        var serverCall = false;
        if (minReq) {
          serverCall = true;
        } else {
          newChartControl.properties[property].chartData = '';
        }

        if (serverCall) {
          if (pb.content.content.chartProperty.properties[property].chartType === 'scatterPlot') {
            var combinedValues = { name: 'Measure', fields: [] };
            var values1 = axesValue[2].fields;
            var values2 = axesValue[3].fields;
            var allValues = values1.concat(values2);
            combinedValues.fields = allValues;
            axesValue.splice(2, 2, combinedValues);
          }

          if (
            pb.content.content.chartProperty.properties[property].chartType === 'heatmap' ||
            pb.content.content.chartProperty.properties[property].chartType === 'crossTab'
          ) {
            var combinedValues2 = { name: 'Dimension', fields: [] };
            var values3 = axesValue[1].fields;
            var values4 = axesValue[2].fields;
            var allValues2 = values3.concat(values4);
            combinedValues2.fields = allValues2;
            axesValue.splice(1, 2, combinedValues2);
          }
          // getChartData(axesValue, pb.content.chartProperty, property, token).then(
          // 	(data:any) => {
          // 		newChartControl.properties[property].chartData = data;
          // 	}
          // );
          if (
            [
              'multibar',
              'stackedBar',
              'horizontalBar',
              'horizontalStacked',
              'line',
              'area',
              'stackedArea',
            ].includes(pb.content.content.chartProperty.properties[property].chartType) // Add split by bucket into old playbooks which don't have it, prevent chart breaking
          ) {
            if (axesValue[2].name !== 'Split By') {
              let combinedValues3 = { name: 'Split By', fields: [] };
              axesValue.splice(2, 0, combinedValues3);
              pb.content.content.chartProperty.properties[property].chartAxes = axesValue;
            }
          }
        }
      }),
    );

    // Get all tables for selected Dataset and display them here
    // var sampleTableRecords: any = { recordsColumnType: {} };
    // await Promise.all(
    //   Object.keys(pb.content.content.chartProperty.properties).map(async (prop) => {
    //     var tableInfo = pb.content.content.chartProperty.properties[prop];

    //     var dc_uid = tableInfo.selectedDs?.connectionId;
    //     var ds_uid = tableInfo.selectedDs?.id;

    //     var selectedTableForThisDataset = pb.content.content.tabTileProps.tablesForSelectedDataSets[
    //       ds_uid
    //     ]?.filter((tbl: any) => tbl.id === tableInfo.selectedTable[ds_uid])[0];

    //     if (selectedTableForThisDataset) {
    //       const savedCalculationOfCurrPropKey = pb.content.content.calculations?.savedCalculations;
    //       let rowLevelcalculations: ICalculationInfo[] = [];
    //       if (savedCalculationOfCurrPropKey) {
    //         /**
    //          * if there is saved calculations for this property key, then filter out the row level calculations
    //          * then only put the calculationInfo field  of those row level calculations in rowLevelcalculations array
    //          */
    //         rowLevelcalculations = savedCalculationOfCurrPropKey
    //           .filter(
    //             (calculation: any) =>
    //               !calculation.isAggregated &&
    //               calculation.datasetId === ds_uid &&
    //               calculation.tableId === selectedTableForThisDataset.id,
    //           )
    //           .map((calculation: any) => calculation.calculationInfo);
    //       }
    //       try {
    //         var tableRecordsResponse = await getTableData(
    //           extract[ds_uid],
    //           dc_uid,
    //           selectedTableForThisDataset,
    //           ds_uid,
    //           state?.parentId || workspaceId,
    //           rowLevelcalculations,
    //           true,
    //         );

    //         var recordsTypeResponse = await getColumnTypes(
    //           extract[ds_uid],
    //           dc_uid,
    //           ds_uid,
    //           selectedTableForThisDataset,
    //           state?.parentId || workspaceId,
    //           tableRecordsResponse?.statusCode === 422 ? [] : rowLevelcalculations,
    //           true,
    //         );

    //         var validCalculations: any[] = [];
    //         if (tableRecordsResponse.statusCode === 422 && tableRecordsResponse.isError) {
    //           let getMissingColumns: any[] = [];
    //           let getErrorCalculations: string[] = [];
    //           for (const cal of rowLevelcalculations) {
    //             const fieldKeys = Object.keys(cal.fields || {});
    //             const missingChecks = await Promise.all(
    //               fieldKeys.map(async (fieldKey: string) => {
    //                 const res = await checkIfMissingColumn(
    //                   cal.fields[fieldKey],
    //                   tableInfo.selectedDs,
    //                   [selectedTableForThisDataset],
    //                 );
    //                 if (res.isMissing) {
    //                   getMissingColumns.push({ [fieldKey]: cal.fields[fieldKey] });
    //                   return true;
    //                 }
    //                 return false;
    //               }),
    //             );

    //             if (missingChecks.includes(true)) {
    //               getErrorCalculations.push(cal?.calculatedFieldName!);
    //             }
    //           }

    //           const selectedDsId = tableInfo.selectedDs.id;

    //           pb.content.content.tabTileProps.missingTablesFormDataSets = [
    //             ...pb.content.content.tabTileProps.missingTablesFormDataSets,
    //             {
    //               [selectedDsId]: getMissingColumns,
    //             },
    //           ];

    //           validCalculations = rowLevelcalculations.filter(
    //             (cal: any) =>
    //               !getErrorCalculations.some((calc: any) => calc === cal.calculatedFieldName),
    //           );
    //           rowLevelcalculations = validCalculations;

    //           tableRecordsResponse = await getTableData(
    //             extract[ds_uid],
    //             dc_uid,
    //             selectedTableForThisDataset,
    //             ds_uid,
    //             state?.parentId || workspaceId,
    //             rowLevelcalculations,
    //             true,
    //           );

    //           recordsTypeResponse = await getColumnTypes(
    //             extract[ds_uid],
    //             dc_uid,
    //             ds_uid,
    //             selectedTableForThisDataset,
    //             state?.parentId || workspaceId,
    //             rowLevelcalculations,
    //             true,
    //           );
    //         }

    //         let tableRecords = tableRecordsResponse?.data;
    //         let recordsType = recordsTypeResponse.data;

    //         // Format the data retrieved to required JSON for saving in store
    //         if (sampleTableRecords[ds_uid] !== undefined) {
    //           sampleTableRecords = update(sampleTableRecords, {
    //             recordsColumnType: {
    //               [ds_uid]: { [selectedTableForThisDataset.id]: { $set: recordsType } },
    //             },
    //             [ds_uid]: { [selectedTableForThisDataset.id]: { $set: tableRecords } },
    //           });
    //         } else {
    //           var recordsCopy = JSON.parse(JSON.stringify(sampleTableRecords));
    //           var dsObj = { [ds_uid]: {} };

    //           recordsCopy = update(recordsCopy, {
    //             $merge: dsObj,
    //             recordsColumnType: { $merge: dsObj },
    //           });

    //           sampleTableRecords = update(recordsCopy, {
    //             recordsColumnType: {
    //               [ds_uid]: {
    //                 [selectedTableForThisDataset.id]: { $set: recordsType },
    //               },
    //             },
    //             [ds_uid]: {
    //               [selectedTableForThisDataset.id]: { $set: tableRecords },
    //             },
    //           });
    //         }
    //       } catch (e) {
    //         Logger('error', 'Error in getTableData', e);
    //       }
    //     }
    //   }),
    // );

    // sessionStorage.setItem('sampleRecords', JSON.stringify(sampleTableRecords));

    setLoading(false);
    Object.keys(pb.content.content.tileState?.tiles).forEach((propKey: string) => {
      if (!pb.content.content.chartProperty.properties[propKey].oldChartName) {
        pb.content.content.chartProperty.properties[propKey].oldChartName = '';
      }
    });

    pb.content.content.chartControl = newChartControl;

    const calculations = (await pb.content.content.calculations?.savedCalculations) || [];
    const savedParameters = await Promise.all(
      pb.content.content.parameters.savedParameters.map(async (parameter: any) => {
        if (parameter.showParameter && parameter.loadFromColumn) {
          const col = parameter.columns;
          const payload: any = {
            tableId: col.tableId,
            fieldName: col.fieldName,
            dataType: col.dataType === 'number' ? 'integer' : col.dataType,
            filterOption: 'allValues',
            timeGrain: col.dataType === 'date' || col.dataType === 'timestamp' ? 'date' : 'year',
          };
          if (col?.has_calculation && col?.calculatedFieldId) {
            const calc = calculations.find(
              (cal: any) => cal.name === col?.fieldName || cal.uuid === col?.calculatedFieldId,
            );
            const flows = calc.calculationInfo.flows;

            payload.isCalculatedField = true;
            payload.calculatedField = [
              {
                calculatedFieldName: calc.name,
                fields: calc.calculationInfo.fields,
                flows: flows,
                conditionFilters: calc.calculationInfo.conditionFilters,
                overrided: calc.calculationInfo.overrideCount > 0,
              },
            ];
          }

          const result = await fetchUniqueOptions('', parameter.datasetId, workspaceId!, payload);

          if (result.isError) {
            return parameter;
          }

          const values = result?.data || [];
          // Remove any userSelection values not present in the new values array
          let userSelection = Array.isArray(parameter?.userSelection)
            ? parameter.userSelection.filter((item: any) => values.includes(item))
            : undefined;
          return { ...parameter, values, ...(userSelection && { userSelection }) };
        }
        return parameter;
      }),
    );
    pb.content.content.parameters.savedParameters = savedParameters;

    //---------initialize show/Hide(start)-------------//
    Object.keys(pb.content.content.tileState?.tiles).forEach((propKey: string) => {
      initializeShowHide(newChartControl, propKey);
    });
    //------------------------(End)--------------------------------//

    // this is added so if we hide a tab which is currently selected, then first visible tab gets selected
    const contentRef = pb.content.content;

    if (contentRef.tabState && contentRef.tabTileProps) {
      const currentTabId = contentRef.tabTileProps.selectedTabId;
      const currentTab = contentRef.tabState.tabs[currentTabId];

      let urlTabMatched = false;

      if (urlTabName) {
        const matchingTabId = contentRef.tabState.tabList.find(
          (tId: number) => contentRef.tabState.tabs[tId].tabName === urlTabName,
        );

        if (matchingTabId && !contentRef.tabState.tabs[matchingTabId].hidden) {
          const tabObj = contentRef.tabState.tabs[matchingTabId];
          contentRef.tabTileProps.selectedTabId = matchingTabId;
          contentRef.tabTileProps.selectedTabName = urlTabName;

          contentRef.tabTileProps.selectedTileId = tabObj.selectedTileId;
          contentRef.tabTileProps.selectedTileName = tabObj.selectedTileName;
          contentRef.tabTileProps.nextTileId = tabObj.nextTileId;

          urlTabMatched = true;
        }
      }

      if (!urlTabMatched && currentTab && currentTab.hidden) {
        // Finding the first tab ID that is NOT hidden
        const firstVisibleTabId = contentRef.tabState.tabList.find(
          (tId: number) => !contentRef.tabState.tabs[tId].hidden,
        );

        if (firstVisibleTabId) {
          const tabObj = contentRef.tabState.tabs[firstVisibleTabId];
          contentRef.tabTileProps.selectedTabId = firstVisibleTabId;
          contentRef.tabTileProps.selectedTabName = tabObj.tabName;

          contentRef.tabTileProps.selectedTileId = tabObj.selectedTileId;
          contentRef.tabTileProps.selectedTileName = tabObj.selectedTileName;
          contentRef.tabTileProps.nextTileId = tabObj.nextTileId;
        }
      }
    }
    //----------

    sessionStorage.setItem(`pb_id_${pb.content.id}`, JSON.stringify(pb.content.content));
    loadPlayBook(pb.content.content);
    const allPropKeysInDashboard = Object.keys(newChartControl.properties);
    allPropKeysInDashboard.forEach((propKey: string) => {
      if (newChartControl.properties[propKey].formatOptions.tooltipFormat === undefined) {
        dispatch(initializeTooltipFormatState(propKey));
      }
      if (newChartControl.properties[propKey].chartMargin.gaugeRadius === undefined) {
        newChartControl.properties[propKey].chartMargin.gaugeRadius = 100;
      }
      if (newChartControl.properties[propKey].formatOptions.gaugeChartFormats === undefined) {
        dispatch(initializeGaugeChartFormats(propKey));
      }
      if (newChartControl.properties[propKey].barLineSettings === undefined) {
        newChartControl.properties[propKey].barLineSettings = {
          lineMeasures: [],
          barMeasures: [],
        };
      }
      if (newChartControl.properties[propKey].sortConfigurations === undefined) {
        newChartControl.properties[propKey].sortConfigurations = [];
      } /**Detects structure and change accordingly */
      //for axis options
      ['xAxis', 'yAxis'].forEach((axisName) => {
        const isOldStructure = axisOptionsOldStructureDetected(
          newChartControl.properties[propKey].axisOptions[axisName],
        );
        if (isOldStructure) {
          modifyAxisOptionsOldStructure(newChartControl.properties[propKey].axisOptions, axisName);
          const measureAxis = pb.content.content.chartProperty.properties[propKey]?.chartAxes?.find(
            (axis: any) => axis.name === 'Measure',
          );
          if (measureAxis?.fields?.length > 0) {
            const allMeasureUids = measureAxis.fields.map((field: any) => field.uId);
            newChartControl.properties[propKey].axisOptions[axisName][1].measuresList =
              allMeasureUids;
          }
        }
      });
      //for x axis formats and y axis formats
      ['xAxisFormats', 'yAxisFormats'].forEach((axisNameFormat) => {
        const isOldStructure = axisFormatOldStructureDetected(
          newChartControl.properties[propKey].formatOptions,
          axisNameFormat,
        );
        if (isOldStructure) {
          modifyAxisFormatOldStructure(
            newChartControl.properties[propKey].formatOptions,
            axisNameFormat,
          );
        }
        //add y axis formats for other series(adding in yAxisFormats only because charts containing multiseries has yAxisFormats only)
        // can use either yAxis or xAxis in axisOptions as series number are in sync for both
        const axisNameOption = newChartControl.properties[propKey].axisOptions.yAxis;
        for (let key in axisNameOption) {
          const yAxisFormats = newChartControl.properties[propKey].formatOptions.yAxisFormats;
          const axisFormatKeys = Object.keys(yAxisFormats);
          //add only when key is not present only for new structure
          if (axisFormatKeys[0].startsWith('1')) {
            // case 1: series is present and format only has separators
            // case 2: series is not present(don't include 1 as 1 is default)
            if (axisFormatKeys.includes(key) && Object.keys(yAxisFormats[key]).length === 3) {
              //add format values(separator value is already present)
              const newlyAddedStates = {
                formatValue: 'Number',
                currencySymbol: '$',
                percentageCalculate: false,
              };
              const prev = yAxisFormats[key];
              yAxisFormats[key] = {
                ...prev,
                ...newlyAddedStates,
              };
            } else if (key !== '1' && !axisFormatKeys.includes(key)) {
              //if series is not present in format then add series and all default formats value
              yAxisFormats[key] = {
                enableRounding: false,
                roundingDigits: 1,
                numberSeparator: 'Abbrev',
                formatValue: 'Number',
                currencySymbol: '$',
                percentageCalculate: false,
              };
            }
          }
        }
      });
    });

    updatePlayBookId(pb.content.name, pb.content.id, pb.content.description, pb.content.content);
    // TODO: add set parameters dispatch method

    //navigate("/dataviewer");
  };

  // switching between Table with all sample records Or just list the columns of selected table
  const handleColumnsOnlyDisplay = (displayOnlyCol: boolean) => {
    toggleColumns(displayOnlyCol);
  };

  // ===========================================================================================
  //                                      UI Components
  // ===========================================================================================
  const dashBoardMenuStyles = {
    color: dashIconColor,
    fill: dashIconColor,
    height: '1.693rem',
    width: '1.693rem',
    padding: '0.2rem',
  };

  const filterIconStyle = {
    ...dashBoardMenuStyles,
    // to make the image white on dark backgrounds
    filter: iconColor === '#ffffff' ? 'brightness(0) invert(1)' : 'none',
  };
  const rmenu: any[] = [
    {
      name: 'Charts',
      activeIcon: <InsertChartIcon fontSize="large" sx={{ ...dashBoardMenuStyles }} />,
      inactiveIcon: <InsertChartOutlinedIcon fontSize="large" sx={{ ...dashBoardMenuStyles }} />,
    },
    {
      name: 'Chart controls',
      activeIcon: <SettingsIcon style={{ ...dashBoardMenuStyles }} />,
      inactiveIcon: <SettingsOutlinedIcon style={{ ...dashBoardMenuStyles }} />,
    },
    {
      name: 'Report Filters',
      activeIcon: <FilterAltIcon sx={{ ...dashBoardMenuStyles }} />,
      inactiveIcon: <FilterAltOutlinedIcon sx={{ ...dashBoardMenuStyles }} />,
    },
  ];

  const renderMenu = rmenu.map((rm: any, i: number) => {
    const isSelected = rm.name === tabTileProps.selectedControlMenu;
    return (
      <div
        style={{ color: '#908f8fff' }}
        key={rm.name}
        className={isSelected ? 'controlsIcon selectedIcon' : 'controlsIcon'}
        onClick={() => {
          if (!isSelected) {
            setMenu(rm.name);
          } else {
            setMenu('');
          }
        }}
        title={rm.name}
      >
        {isSelected ? rm.activeIcon : rm.inactiveIcon}
      </div>
    );
  });

  return (
    <>
      <Helmet prioritizeSeoTags defer>
        <title>
          {playbookState.playBookName
            ? `${playbookState.playBookName} - Playbook | Silzila`
            : 'Unsaved Playbook | Silzila'}
        </title>
      </Helmet>
      {showDataViewer ? (
        <div className="dataViewer">
          {/* <MenuBar from="dataViewer" isOpeningSharedLink={state.isOpeningSharedLink} disableEdit={disableEdit} /> */}
          <MenuBar
            from="dataViewer"
            isOpeningSharedLink={isFromSharedLink || !!shareDashboardLink}
            disableEdit={disableEdit}
            showListofTileMenu={showListofTileMenu}
            setShowListofTileMenu={setShowListofTileMenu}
            dashboardResizeColumn={dashboardResizeColumn}
            setDashboardResizeColumn={setDashboardResizeColumn}
            showDashboardFilter={showDashboardFilter}
            setShowDashboardFilter={setShowDashboardFilter}
            showDashboardFilterEdit={showDashboardFilterEdit}
            setShowDashboardFilterEdit={setShowDashboardFilterEdit}
            iconAlign={iconAlign}
            setIconAlign={setIconAlign}
            reportFilterMenu={reportFilterMenu}
            setReportFilterMenu={setReportFilterMenu}
            parameterMenu={parameterMenu}
            setParameterMenu={setParameterMenu}
          />

          <div
            className="tabArea"
            style={{
              display: pageSettings.fullScreen ? 'none' : '',
              backgroundColor: tabAreaBackgroundColor,
              borderBottom: `1px solid rgb(211, 211, 211)`,
            }}
          >
            <div className="tabItems">
              {tabTileProps.dashMode !== 'Edit' && iconAlign === 'left' ? (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: iconAlign === 'left' ? 'flex-start' : 'flex-end',
                    gap: '1rem',
                    margin: '0.1rem',
                    marginLeft: '0.05rem',
                    // width: '100%',
                  }}
                >
                  <Tooltip
                    title="Dashboard Filter"
                    slotProps={{
                      tooltip: {
                        sx: {
                          fontSize: '12px',
                        },
                      },
                    }}
                  >
                    <img
                      key={'Dashboard Filters'}
                      style={{ ...dashBoardMenuStyles }}
                      src={'/filter_icon_14_12_24.png'}
                      alt={'Dashboard Filters'}
                      onClick={() => {
                        // if (tabTileProps.dashMode === "Edit") {
                        // setShowListofTileMenu(false);
                        // setDashboardResizeColumn(false);
                        setShowDashboardFilter(!showDashboardFilter);
                        // }
                      }}
                      // title={'Dashboard Filters'}
                      className={showDashboardFilter ? 'dashboardMenuIconStyleSelected' : ''}
                    />
                  </Tooltip>
                </div>
              ) : null}
              <TabRibbon
                tabAreaBackgroundColor={tabAreaBackgroundColor}
                iconColor={iconColor}
                selectedTabBackgroundColor={selectedTabBackgroundColor}
              />
            </div>
            {!tabTileProps.showDash &&
            !currentCalculationSession &&
            chartProperties.properties[
              `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`
            ].chartType !== 'richText' ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'right',
                  justifyContent: 'space-between',
                  height: '2rem',
                  width: '152px',
                  // paddingRight: "11px",
                  gap: '1.5rem',
                  marginRight: '10px',
                }}
              >
                {renderMenu}
              </div>
            ) : null}

            {tabTileProps.showDash ? (
              // <div
              //   style={{
              //     display: "flex",
              //     alignItems: "center",
              //     // paddingRight: "8px",
              //   }}
              // >
              <>
                {tabTileProps.dashMode === 'Edit' ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'right',
                      justifyContent: 'center',
                      height: '2rem',
                      // paddingRight: "11px",
                      gap: '1.5rem',
                      paddingRight: '0.2rem',
                    }}
                  >
                    {/* <div
                        className={
                          showListofTileMenu
                            ? "dashboardMenuIconStyleSelected"
                            : "dashboardMenuIconStyle"
                        }
                      > */}
                    {/*  
                  <Tooltip title="Objects">
                    <CategoryIcon
                      sx={{
                        color: palette.primary.contrastText,
                        ...dashBoardMenuStyles,
                      }}
                      className={showObjectsSidebar ? 'dashboardMenuIconStyleSelected' : ''}
                      onClick={() => {
                        if (tabTileProps.dashMode === 'Edit') {
                          setShowListofTileMenu(false);
                          setDashboardResizeColumn(false);
                          setShowDashboardFilter(false);
                          setShowObjectsSidebar(!showObjectsSidebar);
                        }
                      }}
                    />
                  </Tooltip> */}

                    <Tooltip
                      title="Dashboard Layers"
                      slotProps={{
                        tooltip: {
                          sx: {
                            fontSize: '12px',
                          },
                        },
                      }}
                    >
                      {showListofTileMenu ? (
                        <LayersIcon
                          sx={{
                            // color: palette.primary.contrastText,
                            cursor: 'pointer',
                            ...dashBoardMenuStyles,
                          }}
                          className={showListofTileMenu ? 'dashboardMenuIconStyleSelected' : ''}
                          onClick={() => {
                            if (tabTileProps.dashMode === 'Edit') {
                              setDashboardResizeColumn(false);
                              setShowDashboardFilterEdit(false);
                              setShowObjectsSidebar(false);
                              setShowListofTileMenu(!showListofTileMenu);
                            }
                          }}
                        />
                      ) : (
                        <LayersOutlinedIcon
                          sx={{
                            // color: palette.primary.contrastText,
                            cursor: 'pointer',
                            ...dashBoardMenuStyles,
                          }}
                          className={showListofTileMenu ? 'dashboardMenuIconStyleSelected' : ''}
                          onClick={() => {
                            if (tabTileProps.dashMode === 'Edit') {
                              setDashboardResizeColumn(false);
                              setShowDashboardFilterEdit(false);
                              setShowObjectsSidebar(false);
                              setShowListofTileMenu(!showListofTileMenu);
                            }
                          }}
                        />
                      )}
                    </Tooltip>
                    {/* </div> */}
                    {/* <div
                        className={
                          dashboardResizeColumn
                            ? "dashboardMenuIconStyleSelected"
                            : "dashboardMenuIconStyle"
                        }
                      > */}

                    <Tooltip
                      title="Dashboard Theme & Color scheme"
                      slotProps={{
                        tooltip: {
                          sx: {
                            fontSize: '12px',
                          },
                        },
                      }}
                    >
                      {dashboardResizeColumn ? (
                        <ColorLensIcon
                          sx={{
                            // color: palette.primary.contrastText,
                            boxSizing: 'border-box',
                            cursor: 'pointer',
                            ...dashBoardMenuStyles,
                          }}
                          className={dashboardResizeColumn ? 'dashboardMenuIconStyleSelected' : ''}
                          onClick={() => {
                            if (tabTileProps.dashMode === 'Edit') {
                              setShowListofTileMenu(false);
                              setShowObjectsSidebar(false);
                              setShowDashboardFilterEdit(false);
                              setDashboardResizeColumn(!dashboardResizeColumn);
                            }
                          }}
                        />
                      ) : (
                        <ColorLensOutlined
                          sx={{
                            // color: palette.primary.contrastText,
                            boxSizing: 'border-box',
                            cursor: 'pointer',
                            ...dashBoardMenuStyles,
                          }}
                          className={dashboardResizeColumn ? 'dashboardMenuIconStyleSelected' : ''}
                          onClick={() => {
                            if (tabTileProps.dashMode === 'Edit') {
                              setShowListofTileMenu(false);
                              setShowObjectsSidebar(false);
                              setShowDashboardFilterEdit(false);
                              setDashboardResizeColumn(!dashboardResizeColumn);
                            }
                          }}
                        />
                      )}
                    </Tooltip>
                    {/* </div> */}
                    {/* <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "1rem",
                        }}
                        
                      > */}

                    <Tooltip
                      title="Chart Controls"
                      slotProps={{
                        tooltip: {
                          sx: {
                            fontSize: '12px',
                          },
                        },
                      }}
                    >
                      {showObjectsSidebar ? (
                        <SettingsIcon
                          sx={{
                            // color: palette.primary.contrastText,
                            cursor: 'pointer',
                            ...dashBoardMenuStyles,
                          }}
                          className={showObjectsSidebar ? 'dashboardMenuIconStyleSelected' : ''}
                          onClick={() => {
                            if (tabTileProps.dashMode === 'Edit') {
                              setShowListofTileMenu(false);
                              setDashboardResizeColumn(false);
                              setShowDashboardFilter(false);
                              setShowDashboardFilterEdit(false);
                              setShowObjectsSidebar(!showObjectsSidebar);
                            }
                          }}
                        />
                      ) : (
                        <SettingsOutlinedIcon
                          sx={{
                            // color: palette.primary.contrastText,
                            cursor: 'pointer',
                            ...dashBoardMenuStyles,
                          }}
                          className={showObjectsSidebar ? 'dashboardMenuIconStyleSelected' : ''}
                          onClick={() => {
                            if (tabTileProps.dashMode === 'Edit') {
                              setShowListofTileMenu(false);
                              setDashboardResizeColumn(false);
                              setShowDashboardFilter(false);
                              setShowDashboardFilterEdit(false);
                              setShowObjectsSidebar(!showObjectsSidebar);
                            }
                          }}
                        />
                      )}
                    </Tooltip>

                    <Tooltip
                      title="Dashboard Filter"
                      slotProps={{
                        tooltip: {
                          sx: {
                            fontSize: '12px',
                          },
                        },
                      }}
                    >
                      {/* <FilterAltOutlinedIcon
                        sx={{
                          fontSize: "25px",
                        }}
                        onClick={() => {
                          // if (tabTileProps.dashMode === "Edit") {
                          setShowListofTileMenu(false);
                          setDashboardResizeColumn(false);
                          setShowObjectsSidebar(false);
                          setShowDashboardFilter(!showDashboardFilter);
                          // }
                        }}
                      /> */}
                      {showDashboardFilterEdit && showDashboardFilter ? (
                        <FilterAltIcon
                          sx={{
                            cursor: 'pointer',
                            ...dashBoardMenuStyles,
                          }}
                          className={
                            showDashboardFilterEdit ? 'dashboardMenuIconStyleSelected' : ''
                          }
                          onClick={() => {
                            if (tabTileProps.dashMode === 'Edit') {
                              setShowListofTileMenu(false);
                              setDashboardResizeColumn(false);
                              setShowObjectsSidebar(false);

                              // setShowObjectsSidebar(!showObjectsSidebar);
                              setShowDashboardFilter(!showDashboardFilter);
                              setShowDashboardFilterEdit(!showDashboardFilterEdit);
                            }
                          }}
                          // title={'Dashboard Filters'}
                        />
                      ) : (
                        <FilterAltOutlinedIcon
                          sx={{
                            cursor: 'pointer',
                            ...dashBoardMenuStyles,
                          }}
                          className={
                            showDashboardFilterEdit ? 'dashboardMenuIconStyleSelected' : ''
                          }
                          onClick={() => {
                            if (tabTileProps.dashMode === 'Edit') {
                              setShowListofTileMenu(false);
                              setDashboardResizeColumn(false);
                              setShowObjectsSidebar(false);

                              // setShowObjectsSidebar(!showObjectsSidebar);
                              setShowDashboardFilter(!showDashboardFilter);
                              setShowDashboardFilterEdit(!showDashboardFilterEdit);
                            }
                          }}
                          // title={'Dashboard Filters'}
                        />
                      )}
                    </Tooltip>
                    {/* </div> */}
                  </div>
                ) : null}

                {tabTileProps.dashMode !== 'Edit' && iconAlign === 'right' ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      gap: '1rem',
                      marginRight: '0.2rem',
                    }}
                  >
                    <Tooltip
                      title={
                        filterVisibilityMode === 'disable'
                          ? 'Filter Panel is disabled for this tab'
                          : isFilterDisabled && filterVisibilityMode === 'present'
                            ? 'Filter Panel is empty for this tab'
                            : 'Dashboard Filter'
                      }
                      slotProps={{
                        tooltip: {
                          sx: {
                            fontSize: '12px',
                          },
                        },
                      }}
                    >
                      <div>
                        {filterVisibilityMode === 'disable' ||
                        (isFilterDisabled && filterVisibilityMode === 'present') ? (
                          <FilterAltOffIcon
                            sx={{
                              ...dashBoardMenuStyles,
                              cursor: 'default',
                              color: 'rgba(150, 150, 150, 0.5)',
                            }}
                          />
                        ) : showDashboardFilter ? (
                          <FilterAltIcon
                            sx={{
                              cursor: 'pointer',
                              ...dashBoardMenuStyles,
                            }}
                            onClick={() => {
                              setShowObjectsSidebar(false);
                              setShowDashboardFilter(!showDashboardFilter);
                            }}
                            className="dashboardMenuIconStyleSelected"
                          />
                        ) : (
                          <FilterAltOutlinedIcon
                            sx={{
                              cursor: 'pointer',
                              ...dashBoardMenuStyles,
                            }}
                            onClick={() => {
                              setShowObjectsSidebar(false);
                              setShowDashboardFilter(!showDashboardFilter);
                            }}
                          />
                        )}
                      </div>
                    </Tooltip>
                  </div>
                ) : null}
              </>
            ) : // </div>
            null}
          </div>
          {/* Show tile page or Dashboard */}
          {tabTileProps.showDash || state?.isOpeningSharedLink || isFromSharedLink ? (
            <DashBoard
              playBookId={state?.playbookId || playbookId}
              showListofTileMenu={showListofTileMenu}
              dashboardResizeColumn={dashboardResizeColumn}
              showDashBoardFilterMenu={showDashboardFilter}
              showDashboardFilterEdit={showDashboardFilterEdit}
              setShowListofTileMenu={setShowListofTileMenu}
              setDashboardResizeColumn={setDashboardResizeColumn}
              setShowDashBoardFilter={setShowDashboardFilter}
              showObjectsSidebar={showObjectsSidebar}
              setShowObjectsSidebar={setShowObjectsSidebar}
              setShowDashboardFilterEdit={setShowDashboardFilterEdit}
              iconAlign={iconAlign}
              setIconAlign={setIconAlign}
              reportFilterMenu={reportFilterMenu}
              setReportFilterMenu={setReportFilterMenu}
              parameterMenu={parameterMenu}
              setParameterMenu={setParameterMenu}
              setMapJSON={setMapJSON}
              setLoading={setLoading}
              tabAreaBackgroundColor={tabAreaBackgroundColor}
              iconColor={iconColor}
              selectedTabBackgroundColor={selectedTabBackgroundColor}
            />
          ) : (
            <React.Fragment>
              <DataViewerMiddle
                tabId={tabTileProps.selectedTabId}
                tileId={tabTileProps.selectedTileId}
                reportFilterMenu={reportFilterMenu}
                setReportFilterMenu={setReportFilterMenu}
                parameterMenu={parameterMenu}
                setParameterMenu={setParameterMenu}
                mapJSON={mapJSON}
                setMapJSON={setMapJSON}
                setLoading={setLoading}
              />
              {tabTileProps.showDataViewerBottom && !pageSettings.fullScreen ? (
                <DataViewerBottom pbId={state?.playbookId || playbookId} />
              ) : null}
            </React.Fragment>
          )}
          {tabTileProps.dashMode === 'TV Display' && (
            <div className="tv-display-overlay">
              <div className="tv-display-popover centered-content">
                {/* Header */}
                <div className="popover-header">
                  <h4>TV Display</h4>
                </div>
                <CloseIcon
                  style={{ color: '#666666' }}
                  className="close-icons"
                  onClick={() => {
                    dispatch(toggleDashMode('Present'));
                    dispatch(toggleDashModeInTab(tabTileProps.selectedTabId, 'Present'));
                  }}
                />

                {/* TRANSITION SECTION */}
                <div className="section-header-rows">
                  <h3>Transition</h3>

                  {/* Tab Selection */}
                  <div className="subsection">
                    <p>Choose Tabs</p>
                    <div className="tab-checkbox-section">
                      <div className="scrollable">
                        {tabState?.tabList
                          ?.filter((tabId: number) => !tabState.tabs[tabId].hidden)
                          .map((tabId: number) => {
                            const tab = tabState.tabs[tabId];
                            return (
                              <div className="checkbox-item" key={tabId}>
                                <Checkbox
                                  checked={tvSettings.selectedTabArray?.includes(tabId)}
                                  sx={{
                                    marginRight: '-8px',
                                  }}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedTabs([...tvSettings.selectedTabArray, tabId]);
                                      dispatch(
                                        setTVSelectedTabs([...tvSettings.selectedTabArray, tabId]),
                                      );
                                    } else {
                                      setSelectedTabs(
                                        tvSettings.selectedTabArray.filter(
                                          (id: number) => id !== tabId,
                                        ),
                                      );
                                      dispatch(
                                        setTVSelectedTabs(
                                          tvSettings.selectedTabArray.filter(
                                            (id: number) => id !== tabId,
                                          ),
                                        ),
                                      );
                                    }
                                  }}
                                />
                                <span>{tab.tabName}</span>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>

                  {/* Transition Timer */}
                  <div className="input-row-inlines">
                    <label htmlFor="transition-timer">
                      Transition Timer (seconds)
                      <span
                        className="tooltip-icon"
                        title="Controls how often the display rotates between tabs."
                      >
                        <Info size={16} />
                      </span>
                    </label>
                    <input
                      id="transition-timer"
                      type="number"
                      min={5}
                      max={60}
                      value={transitionTime}
                      onChange={(e) => dispatch(setTVTransitionTime(Number(e.target.value)))}
                      className="number-inputs"
                    />
                  </div>
                  <div className="error-message">
                    {transitionTime < 5 && 'Transition time must be at least 5 seconds'}
                  </div>
                </div>

                {/* DATA REFRESH SECTION */}
                <div className="section-header-row data-refresh-header">
                  <div className="data-refresh-title">
                    <h3>Data Refresh</h3>
                    <span
                      className="tooltip-icon"
                      title="Controls how data gets refreshed in the tabs."
                    >
                      <Info size={16} />
                    </span>
                  </div>

                  <Switch
                    checked={dataRefreshEnableds}
                    onChange={(e) => dispatch(setTVDataRefreshEnabled(e.target.checked))}
                    className="refresh-switch"
                  />
                </div>

                {dataRefreshEnableds && (
                  <>
                    <div className="input-row-inline justify-end">
                      <label htmlFor="data-refresh">Refresh Interval</label>
                      <FormControl>
                        <Select
                          id="refresh-unit"
                          value={dataRefreshUnit}
                          onChange={(e) =>
                            dispatch(setTVDataRefreshUnit(e.target.value as 'Minutes' | 'Hours'))
                          }
                          sx={{
                            width: '90px',
                            height: '29px',
                          }}
                          MenuProps={{
                            disablePortal: true, // prevents portal from breaking layout
                            PaperProps: {
                              sx: {
                                backgroundColor: 'white',
                              },
                            },
                          }}
                        >
                          <MenuItem value="Minutes">Minutes</MenuItem>
                          <MenuItem value="Hours">Hours</MenuItem>
                        </Select>
                      </FormControl>

                      <input
                        id="data-refresh"
                        type="number"
                        min={dataRefreshUnit === 'Minutes' ? 5 : 1}
                        max={dataRefreshUnit === 'Minutes' ? 59 : 23}
                        value={dataRefreshTime}
                        onChange={(e) => dispatch(setTVDataRefreshTime(Number(e.target.value)))}
                        className="number-input"
                      />
                    </div>
                    <div
                      className="error-message"
                      style={{
                        marginLeft: '108px',
                      }}
                    >
                      {dataRefreshEnableds &&
                        ((dataRefreshUnit === 'Minutes' && dataRefreshTime < 5) ||
                          (dataRefreshUnit === 'Hours' && dataRefreshTime < 1)) &&
                        'Refresh Time must be at least 5 minutes'}
                    </div>
                  </>
                )}

                {/* ACTION */}
                <div
                  className="popover-actions"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Tooltip
                    title={disabledTVDisp ? disabledMessage : 'Set and go to TV Display mode'}
                    // arrow
                    slotProps={{
                      popper: {
                        disablePortal: true,
                      },
                      tooltip: {
                        sx: {
                          fontSize: '12px',
                        },
                      },
                    }}
                  >
                    <span>
                      <CustomButton
                        fullWidth
                        onClick={() => {
                          dispatch(toggleDashMode('Present'));
                          dispatch(toggleDashModeInTab(tabTileProps.selectedTabId, 'Present'));

                          window.dispatchEvent(new CustomEvent('saveFromTvDisplay'));
                        }}
                        disabled={disabledTVDisp}
                      >
                        Set and Go
                      </CustomButton>
                    </span>
                  </Tooltip>
                </div>
              </div>
            </div>
          )}

          {/* Dashboard present and edit mode related UI */}
          {/* Also Hide in full screen mode */}
          {tabTileProps.dashMode === 'Edit' && !pageSettings.fullScreen && (
            <div
              className="tilearea"
              style={{
                alignItems: 'center',
                paddingTop: 0,
                backgroundColor: tabAreaBackgroundColor,
              }}
            >
              {/* <div className="tileDashboard">

                  <span
                    title="Dashboard"
                    className={
                      tabTileProps.showDash
                        ? "plusTile commonTile indiItemHighlightTile"
                        : "plusTile commonTile indiItemTile"
                    }
                    style={{ fontSize: "12px" }}
                    onClick={() => {
                      showDashBoard(tabTileProps.selectedTabId, true);
                    }}
                  >
                    Dashboard
                  </span>
                </div> */}
              <Tooltip
                title="Dashboard"
                slotProps={{
                  tooltip: {
                    sx: {
                      fontSize: fontSize.medium,
                    },
                  },
                }}
              >
                <Typography
                  component="div"
                  onClick={() => {
                    showDashBoard(tabTileProps.selectedTabId, true);
                  }}
                  //  className={tabTileProps.showDash ? 'indiItemHighlightTile' : 'indiItemTile'}
                  sx={{
                    fontSize: fontSize.medium,
                    display: 'flex',
                    lineHeight: '2rem',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // color: 'primary.contrastText',
                    textAlign: 'center',
                    border: '1px solid rgba(224, 224, 224, 1)',
                    paddingInline: '0.5rem',
                    backgroundColor: tabTileProps.showDash
                      ? selectedTabBackgroundColor
                      : tabAreaBackgroundColor,
                    color: iconColor,
                    height: '1.7rem',
                    cursor: 'pointer',
                    '&:hover': {
                      color: 'rgb(64, 64, 64)',
                      background: 'white',
                    },
                  }}
                >
                  Dashboard
                </Typography>
              </Tooltip>
              <div className="tileItems" style={{ height: '1.7rem', padding: 0 }}>
                <TileRibbon
                  tabAreaBackgroundColor={tabAreaBackgroundColor}
                  iconColor={iconColor}
                  selectedTabBackgroundColor={selectedTabBackgroundColor}
                />
              </div>

              {!tabTileProps.showDash &&
              chartProperties?.properties[propKey]?.chartType !== 'richText' ? (
                tabTileProps.showDataViewerBottom ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1.5rem',
                      width: '222px',
                      justifyContent: 'end',
                      height: '1.5rem',
                    }}
                  >
                    {/* <div className="showTableColumns"> */}
                    <ButtonGroup
                      variant="outlined"
                      aria-label="Basic button group"
                      sx={{
                        // marginBottom: "0.3rem",
                        height: '1.5rem',
                        '& .MuiButtonGroup-grouped': {
                          border: '2px solid rgba(224, 224, 224, 1)',
                          borderRadius: '0',
                        },
                      }}
                    >
                      <Tooltip
                        title="Show full table"
                        key="Show full table"
                        slotProps={{
                          tooltip: {
                            sx: {
                              fontSize: '12px',
                            },
                          },
                        }}
                      >
                        <Button
                          sx={{
                            margin: 0,
                            padding: 0,
                            backgroundColor: !tabTileProps.columnsOnlyDisplay
                              ? 'rgb(224, 224, 224)'
                              : 'white',
                            width: '52px',
                            '&:hover': {
                              border: '2px solid #E0E0E0',
                              backgroundColor: '#E8E8E8',
                            },
                            color: '#E0E0E0',
                          }}
                          onClick={() => handleColumnsOnlyDisplay(false)}
                        >
                          <img
                            src={'/table_icon.svg'}
                            style={{
                              margin: 0,
                              padding: 0,
                              border: 'none',
                              width: '12px',
                              height: '12px',
                              backgroundColor: !tabTileProps.columnsOnlyDisplay
                                ? 'rgb(224, 224, 224)'
                                : 'white',
                            }}
                            onClick={() => handleColumnsOnlyDisplay(false)}
                            alt="Show full table"
                          />
                        </Button>
                        {/* <TableChartOutlinedIcon
                              fontSize="small"
                                sx={{
                                  color: "#666",
                                  fontSize:"15px"
                                }}
                              /> */}
                      </Tooltip>
                      <Tooltip
                        title="Show Column Headers only"
                        slotProps={{
                          tooltip: {
                            sx: {
                              fontSize: '12px',
                            },
                          },
                        }}
                      >
                        <Button
                          sx={{
                            margin: 0,
                            padding: 0,
                            backgroundColor: tabTileProps.columnsOnlyDisplay
                              ? 'rgb(224, 224, 224)'
                              : 'white',
                            width: '52px',
                            '&:hover': {
                              border: '2px solid #E0E0E0',
                              backgroundColor: '#E8E8E8',
                            },
                            color: '#E0E0E0',
                          }}
                          onClick={() => handleColumnsOnlyDisplay(true)}
                        >
                          <TableRowsIcon
                            fontSize="small"
                            style={{
                              color: '#858585',
                              fontSize: '15px',
                            }}
                          />
                        </Button>
                      </Tooltip>
                    </ButtonGroup>
                    {/* </div> */}
                    <div
                      // className="tableDisplayToggle"
                      onClick={handleTableDisplayToggle}
                      style={{
                        width: '2rem',
                        marginRight: '0.8rem',
                        paddingTop: '0.2rem',
                      }}
                    >
                      <Tooltip
                        title="Hide table view"
                        slotProps={{
                          tooltip: {
                            sx: {
                              fontSize: '12px',
                            },
                          },
                        }}
                      >
                        <KeyboardArrowDownIcon
                          style={{
                            fontSize: '20px',
                            color: '#858585',
                          }}
                        />
                      </Tooltip>
                    </div>
                  </div>
                ) : (
                  <div className="tableDisplayToggle" onClick={handleTableDisplayToggle}>
                    <Tooltip
                      title="Show table view"
                      slotProps={{
                        tooltip: {
                          sx: {
                            fontSize: '12px',
                          },
                        },
                      }}
                    >
                      <KeyboardArrowUpIcon style={{ fontSize: '20px', color: '#808080' }} />
                    </Tooltip>
                  </div>
                )
              ) : null}
            </div>
          )}
          <PopUpSpinner show={loading} />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',

            background: '#f5f7fa',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '48px 40px',
              borderRadius: '16px',
              background: '#ffffff',
              boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
              maxWidth: '420px',
              width: '90%',
            }}
          >
            {/* Broken link SVG illustration */}
            <div
              style={{
                width: '100px',
                height: '100px',
                borderRadius: '50%',
                background: '#fef2f2',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {/* Left chain half */}
                <path d="M9 17H7a5 5 0 0 1 0-10h2" stroke="#d4d4d8" strokeWidth="2" />
                {/* Right chain half */}
                <path d="M15 7h2a5 5 0 0 1 0 10h-2" stroke="#d4d4d8" strokeWidth="2" />
                {/* Broken gap — left stub */}
                <line x1="8" y1="12" x2="10.5" y2="12" stroke="#d4d4d8" strokeWidth="2" />
                {/* Broken gap — right stub */}
                <line x1="13.5" y1="12" x2="16" y2="12" stroke="#d4d4d8" strokeWidth="2" />
                {/* Red diagonal slash */}
                <line x1="4" y1="4" x2="20" y2="20" stroke="#ef4444" strokeWidth="2" />
              </svg>
            </div>

            <h2
              style={{
                color: '#1f2937',
                margin: '0 0 8px 0',
                fontSize: '20px',
                fontWeight: 700,
                letterSpacing: '-0.3px',
              }}
            >
              Link is broken or expired
            </h2>

            <p
              style={{
                color: '#6b7280',
                fontSize: '13.5px',
                margin: '0 0 28px 0',
                textAlign: 'center',
                lineHeight: '1.7',
              }}
            >
              The shared dashboard link you're trying to access is no longer valid. Please contact
              the person who shared it for an updated link.
            </p>

            <a
              href={localEndPoint}
              style={{
                fontSize: '14px',
                fontWeight: 600,
                color: '#2bb9bb',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              Go to Homepage
            </a>
          </div>
        </div>
      )}
    </>
  );
}

// ===========================================================================================
//                                 REDUX MAPPING STATE AND DISPATCH TO PROPS
// ===========================================================================================

const mapStateToProps = (state: TabTileStateProps2 & any, ownProps: any) => {
  return {
    tabTileProps: state.tabTileProps,
    chartProperties: state.chartProperties,
    token: state.isLogged.accessToken,
    calculations: state.calculations,
    chartControls: state.chartControls,
    tileState: state.tileState,
    pageSettings: state.pageSettings,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    showDashBoard: (tabId: number, showDash: boolean) =>
      dispatch(setShowDashBoard(tabId, showDash)),
    toggleColumns: (displayOnlyCol: boolean) => dispatch(toggleColumnsOnlyDisplay(displayOnlyCol)),
    toggleDataViewerBottom: (show: boolean) => dispatch(toggleShowDataViewerBottom(show)),
    setMenu: (menu: string) => dispatch(setSelectedControlMenu(menu)),
    setSelectedDataSetList: (dataset: string) => dispatch(setSelectedDataSetList(dataset)),
    setTablesForDs: (tablesObj: any) => dispatch(setTablesForSelectedDataSets(tablesObj)),
    setSelectedDs: (propKey: string, selectedDs: any) =>
      dispatch(setSelectedDsInTile(propKey, selectedDs)),
    setSelectedDatasetForDynamicMeasure: (dataset: any) =>
      dispatch(setSelectedDatasetForDynamicMeasure(dataset)),
    loadPlayBook: (playBook: any) => dispatch(loadPlaybook(playBook)),
    updatePlayBookId: (
      playBookName: string,
      playBookUid: string,
      description: string,
      oldContent?: string | any,
    ) => dispatch(updatePlaybookUid(playBookName, playBookUid, description, oldContent)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataViewer);
